module.exports = __webpack_public_path__ + "static/img/banner-aug-1.f49642e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-aug-1.png
// module id = z4Fi
// module chunks = 1